import { render } from "./TimetableSection.vue?vue&type=template&id=5401d63f&scoped=true"
import script from "./TimetableSection.vue?vue&type=script&lang=js"
export * from "./TimetableSection.vue?vue&type=script&lang=js"

import "./TimetableSection.vue?vue&type=style&index=0&id=5401d63f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guifernandespro\\development\\projects\\vue_icon-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5401d63f"]])

export default __exports__